/**
 *
 * @param {fn} handler The event handler function to call
 * @param {*} target The HTMLElement that was interacted with to trigger the event
 * @param {*} e The event object from the triggered event
 * @param {*} args Additional arguments triggered with the event
 * @returns An object containing eventObjects and eventTypes for the called event.
 * @example
 * // return value
 * {
 *		eventObjects: [eventObject,eventObject],
 *		// Set of eventTypes for the handled event.
 *		// Most like this will only have one thing...but support is there for multiple to be returned.
 *		eventTypes: ['ddc.link.generic']
 * }
 * // What is an eventObject?
 * {
 * 	eventType: 'ddc.link.generic',
 * 	eventData: {
 * 		item1: 'item1'
 * 	}
 * }
 */
const getEventObjects = async (handler, args) => {
	const eventObjects = [];
	const eventObject = await handler(...args);

	if (eventObject) {
		if (Array.isArray(eventObject)) {
			// form onPage returns an array
			eventObject.forEach((eventObj) => {
				eventObjects.push(eventObj);
			});
		} else {
			eventObjects.push(eventObject);
		}
	}

	return eventObjects;
};

export default getEventObjects;
